import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { Button, Typography, useMediaQuery } from '@material-ui/core';
import 'react-modal-video/css/modal-video.min.css';

// CONSTANTS
import { ROUTE_DISCOVER } from '@/constants/routes';
import { LOCATIONS_HOME_PARTNER_PAGE } from '@/constants/locations';

// UTILITY
import { analyticsStartFormLink } from '@/utility/analytics';

// COMPONENTS
import Link from '@/components/Link';

const LeftSection = ({ partner }) => {
  const [t] = useTranslation();
  const downXs = useMediaQuery(({ breakpoints }) => breakpoints.down('xs'));
  const textOverwrites = partner.text_overwrites || {};

  const handleStartClick = () => {
    analyticsStartFormLink({
      location: 'Center',
      type: 'Button',
    });
  };

  return (
    <div className="welcome__left">
      <Typography className="welcome__title m-b-15" variant={downXs ? 'h3' : 'h1'} component="h1">
        {textOverwrites.streamtv_left_title ||
          t('partnerStreamTV.welcome.title', { partner_name: partner.partner_name })}
      </Typography>
      <Typography className={clsx('welcome__subtitle m-b-30', downXs ? 'p5' : 'p2')}>
        {textOverwrites.streamtv_left_subtitle || t('partnerStreamTV.welcome.subtitle')}
      </Typography>
      <Button
        component={Link}
        onClick={handleStartClick}
        to={ROUTE_DISCOVER}
        color="primary"
        location={LOCATIONS_HOME_PARTNER_PAGE}
        size={clsx(downXs ? 'medium' : 'large')}
      >
        {textOverwrites.streamtv_left_button_text || t('buttons.discoverApps')}
      </Button>
    </div>
  );
};

LeftSection.propTypes = {
  partner: PropTypes.object.isRequired,
};

export default React.memo(LeftSection);
